import React from 'react';

import Lozenge from '@atlaskit/lozenge/new/lozenge';

export default (): React.JSX.Element => <Lozenge>Subtle default lozenge</Lozenge>;
